// Dates as 'YYYY-MM-DD' strings, weeks Monday-first. Shared by Timesheets and Schedule.
const parse = (s) => new Date(`${s}T00:00:00`);
export const toISODate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// The calendar day of an API value: a plain 'YYYY-MM-DD' as is, a timestamp in the browser's own day.
export const dayOf = (v) => (/^\d{4}-\d{2}-\d{2}$/.test(v) ? v : toISODate(new Date(v)));
export const addDays = (s, n) => {
  const d = parse(s);
  d.setDate(d.getDate() + n);
  return toISODate(d);
};
export const mondayOf = (s) => addDays(s, -((parse(s).getDay() + 6) % 7));
export const weekDates = (weekStart) => Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
export const isWeekend = (s) => [0, 6].includes(parse(s).getDay());
export const dayName = (s, style = "short") => parse(s).toLocaleDateString("en-GB", { weekday: style });
// Whole days from a to b (b - a).
export const diffDays = (a, b) => Math.round((parse(b) - parse(a)) / 86400000);
export const formatDay = (s, withYear = false) =>
  parse(s).toLocaleDateString("en-GB", { day: "numeric", month: "short", ...(withYear ? { year: "numeric" } : {}) });
